(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1762],{

/***/ 20210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69081);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48641);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18132);
/* harmony import */ var src_components_NltOffers___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92668);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20213);
/* harmony import */ var src_utils_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);











var NltContentInfo = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return __webpack_require__.e(/* import() */ 1427).then(__webpack_require__.bind(__webpack_require__, 41427));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(41427)];
    }
  }
});
var MobileActionBar = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 88124));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(88124)];
    }
  }
});
var NltOffersContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return __webpack_require__.e(/* import() */ 1410).then(__webpack_require__.bind(__webpack_require__, 11410));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(11410)];
    }
  }
});
var PageHeaderContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return __webpack_require__.e(/* import() */ 8750).then(__webpack_require__.bind(__webpack_require__, 46677));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46677)];
    }
  }
});

var NltSearchPage = function NltSearchPage(_ref) {
  var page = _ref.page;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var visibleOnMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  var requestedPage = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function (state) {
    return state.nlt.listingPage;
  });
  (0,src_utils_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useBackButton */ .Kx)();
  var crumbs = [{
    page: 'Home Page',
    href: '/',
    title: 'Home Page'
  }, {
    page: 'Offerte Noleggio a Lungo Termine',
    href: '/noleggio-a-lungo-termine',
    title: 'Offerte Noleggio a Lungo Termine'
  }];
  var metaPage = Math.max(page || 0, requestedPage || 0, 1);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
    bgColor: "baseNeutral.100",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: "2825298273",
      children: ["@media (max-width:600px){#CookiebotWidget{bottom:66px !important;z-index:calc(var(--cp-zIndices-modal) - 1) !important;}}"]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_5__/* .Head */ .Fb, {
      title: t('nltPage:header.title', {
        page: metaPage && metaPage > 1 ? " pag. ".concat(metaPage) : ''
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_5__/* .MetaTags */ .NR, {
      meta: metaPage && metaPage > 1 ? t("nltPage:metaNextPages", {
        returnObjects: true,
        page: metaPage
      }) : t("nltPage:meta", {
        returnObjects: true
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_5__/* .LinkRel */ .Mu, {
      rel: "canonical",
      href: "https://www.carplanner.com/noleggio-a-lungo-termine".concat(page && page > 1 ? "?pagina=".concat(page) : '')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(PageHeaderContainer, {
      title: t('nltPage:header.title'),
      description: t('nltPage:header.description'),
      crumbs: crumbs,
      linkHref: "/come-funziona-noleggio-a-lungo-termine",
      linkTitle: t('nltPage:header.howItWorksLink'),
      domain: "rent"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
      w: "100%",
      display: "inline-block",
      pb: "24px",
      pl: "1.5rem",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(src_components_NltOffers___WEBPACK_IMPORTED_MODULE_4__/* .ActionBar */ .ol, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(NltOffersContainer, {})]
    }), requestedPage < 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(NltContentInfo, {
      title: t('nltPage:infoSection.title'),
      description: t('nltPage:infoSection.text'),
      asHtml: true
    }), visibleOnMobile && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(MobileActionBar, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (NltSearchPage);

/***/ }),

/***/ 20213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Do": function() { return /* reexport */ Offers_FilterSwitch; },
  "dB": function() { return /* reexport */ Offers_FilterTag; },
  "TY": function() { return /* reexport */ Offers_FilterTagCheckbox; },
  "Sz": function() { return /* reexport */ Offers_FilterTagImage; },
  "Fb": function() { return /* reexport */ common_Head; },
  "Mu": function() { return /* reexport */ LinkRel; },
  "NR": function() { return /* reexport */ common_MetaTags; },
  "$j": function() { return /* reexport */ common_Spinner; }
});

// UNUSED EXPORTS: SpaceL, SpaceXS, SpaceXXL, SpaceXXL4, SpaceXXL5, SpaceXXL6, Title

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
;// CONCATENATED MODULE: ./src/components/common/Title.tsx

var Title = styled_components_browser_esm["default"].h2.withConfig({
  displayName: "Title",
  componentId: "sc-ajob4w-0"
})(["margin-top:25px;margin-bottom:15px;font-size:30px;"]);
/* harmony default export */ var common_Title = ((/* unused pure expression or super */ null && (Title)));
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/containers/data/slider.json
var slider = __webpack_require__(34755);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/common/Head.tsx








var Head = function Head(_ref) {
  var title = _ref.title;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
      children: [title || t('common:header.title'), ' ', "| CarPlanner"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Regular.woff2",
      as: "font"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Medium.woff2",
      as: "font"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-SemiBold.woff2",
      as: "font"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: slider/* image */.BH
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: slider/* boxes.0.image */.qk[0].image
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: slider/* boxes.1.image */.qk[1].image
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "Cookiebot",
      src: "https://consent.cookiebot.com/uc.js",
      "data-cbid": "93243ddb-bf78-4f8b-b7bc-52a29e9f53e5",
      "data-blockingmode": "auto",
      type: "text/javascript",
      async: true
    })]
  });
};

/* harmony default export */ var common_Head = (Head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
;// CONCATENATED MODULE: ./src/components/common/MetaTags.tsx





var MetaTags = function MetaTags(_ref) {
  var meta = _ref.meta;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: meta.length > 0 && meta.map(function (tag) {
      if (tag.name) {
        var _tag$content;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: tag.name,
          content: tag.override && tag.override.trim() !== '' ? tag.override : (_tag$content = tag.content) !== null && _tag$content !== void 0 ? _tag$content : ''
        }, tag.name);
      }

      if (tag.property) {
        var _tag$content2;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: tag.property,
          content: tag.override && tag.override.trim() !== '' ? tag.override : (_tag$content2 = tag.content) !== null && _tag$content2 !== void 0 ? _tag$content2 : ''
        }, tag.property);
      }

      return null;
    })
  });
};

/* harmony default export */ var common_MetaTags = (MetaTags);
var LinkRel = function LinkRel(_ref2) {
  var rel = _ref2.rel,
      href = _ref2.href,
      crossOrigin = _ref2.crossOrigin,
      type = _ref2.type,
      as = _ref2.as;
  var url = '';

  if (rel === 'canonical' && href.indexOf('?') >= 0) {
    // rimuove eventuali parametri querystring
    var _href$split = href.split('?');

    var _href$split2 = (0,slicedToArray/* default */.Z)(_href$split, 1);

    url = _href$split2[0];
  } else {
    url = href;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: rel,
      href: url,
      crossOrigin: crossOrigin || null,
      type: type || null,
      as: as || null
    })
  });
};
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(83292);
;// CONCATENATED MODULE: ./src/components/common/Spinner.tsx





var LogoSpinner = function LogoSpinner() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 35",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#2EC58D",
          d: "M40.5,19c-3.6-3.4-9.2-3.2-12.6,0.4l-2,2.2l-0.9,1v0l-0.7,0.8l-5.1,5.5c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c-1.3,1.3-3.1,1.7-4.8,1.2c0,0,0,0,0,0c-0.1,0-0.3-0.1-0.4-0.1c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.4-0.2c0,0,0,0,0,0 c-0.1-0.1-0.2-0.1-0.3-0.2c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0 c0,0-0.1-0.1-0.1-0.1l0,0c-1.9-1.8-2-4.9-0.2-6.8c1.8-1.9,4.9-2,6.8-0.2c0.6,0.5,1,1.2,1.2,1.8l3-3.2c-0.4-0.6-0.8-1.2-1.4-1.7 c-3.6-3.4-9.2-3.2-12.6,0.4c-2.9,3.1-3.2,7.6-1,11c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2 c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2C8.9,31.3,9,31.4,9,31.4c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2 c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2 c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c3.6,2.8,8.8,2.5,12-0.9l2-2.1c0,0,0.9-1,0.9-1l0.7-0.8l5.1-5.6c0,0,0,0,0,0 c1.8-1.9,4.9-2,6.8-0.2c1.9,1.8,2,4.9,0.2,6.8c-1.8,1.9-4.9,2-6.8,0.2c-0.6-0.5-1-1.2-1.2-1.8l-3,3.2c0.4,0.6,0.8,1.2,1.4,1.7 c3.6,3.4,9.2,3.2,12.6-0.4C44.3,28,44.1,22.3,40.5,19z"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#2EC58D",
          d: "M45.8,7.7C42.3,2.6,36.7,0,29.2,0C22.8,0,15.6,3,9.5,8.3C3.6,13.4,0,19.7,0,25.1h5.4c0-3.7,2.9-8.6,7.7-12.7 c5-4.3,11-6.9,16.1-6.9c2.3,0,4.3,0.3,6,0.8c0,0,0.1,0,0.1,0.1c4.7,2.1,7.1,5.9,8.3,9.5c0.7,2.6,1.1,5.7,1.1,9.3l5.4,0 c0,0,0,0,0,0h0C50.1,17.6,48.7,11.9,45.8,7.7z"
        })]
      })
    })
  });
};

var Spinner = function Spinner(_ref) {
  var isVisible = _ref.isVisible;

  var _useDisclosure = (0,index_esm/* useDisclosure */.qY)(),
      onClose = _useDisclosure.onClose;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Modal */.u_, {
    isOpen: isVisible,
    onClose: onClose,
    isCentered: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ModalOverlay */.ZA, {
      bg: "blackAlpha.700"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* ModalContent */.hz, {
      background: "transparent",
      alignItems: "center",
      boxShadow: "none",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "spinner-circle"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "spinner-logo",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoSpinner, {})
      })]
    })]
  });
};

/* harmony default export */ var common_Spinner = (Spinner);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./src/themes/index.tsx + 3 modules
var themes = __webpack_require__(37930);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterTag.tsx






var FilterTag = function FilterTag(_ref) {
  var isSelected = _ref.isSelected,
      hasCloseButton = _ref.hasCloseButton,
      label = _ref.label,
      onClick = _ref.onClick;

  var _useState = (0,react.useState)(false),
      isMounted = _useState[0],
      setMount = _useState[1];

  (0,react.useEffect)(function () {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  var bgColor = isSelected ? themes/* theme.colors.primaryGreen.300 */.r.colors.primaryGreen[300] : 'white';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
    color: themes/* theme.colors.primaryGreen.900 */.r.colors.primaryGreen[900],
    variant: "outline",
    fontFamily: "Montserrat-Medium",
    fontWeight: "normal",
    size: "xs",
    h: "32px",
    mr: 1,
    my: 1,
    borderRadius: 4,
    bg: bgColor,
    _hover: {
      backgroundColor: bgColor
    },
    borderColor: themes/* theme.colors.primaryGreen.300 */.r.colors.primaryGreen[300],
    userSelect: "none",
    onClick: onClick,
    rightIcon: hasCloseButton ? /*#__PURE__*/(0,jsx_runtime.jsx)(icons_dist_index_esm/* CloseIcon */.Tw, {
      boxSize: "0.7rem"
    }) : undefined,
    children: label
  });
};

/* harmony default export */ var Offers_FilterTag = (FilterTag);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/index.esm.js + 1 modules
var checkbox_dist_index_esm = __webpack_require__(9135);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterTagCheckbox.tsx





var FilterTagCheckbox = function FilterTagCheckbox(_ref) {
  var isChecked = _ref.isChecked,
      label = _ref.label,
      onChange = _ref.onChange;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
    fontFamily: "Montserrat-Medium",
    color: "baseDark",
    borderColor: themes/* theme.colors.primaryGreen.900 */.r.colors.primaryGreen[900],
    colorScheme: "primaryGreenCheckboxFilter",
    isChecked: isChecked,
    display: "block",
    size: "lg",
    lineHeight: "1.2",
    mb: "s",
    className: "filterCheck",
    onChange: onChange,
    children: label
  });
};

/* harmony default export */ var Offers_FilterTagCheckbox = (FilterTagCheckbox);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterTagImage.tsx







var FilterTagImage = function FilterTagImage(_ref) {
  var isSelected = _ref.isSelected,
      label = _ref.label,
      icon = _ref.icon,
      iconAlt = _ref.iconAlt,
      onClick = _ref.onClick,
      isMobile = _ref.isMobile;
  var borderColor = isSelected ? "".concat(themes/* theme.colors.green.600 */.r.colors.green[600], ", 0 2px 8px 0 rgba(44, 190, 97, 0.13)") : themes/* theme.colors.borders.grey */.r.colors.borders.grey;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Badge */.Ct, {
    suppressHydrationWarning: true,
    as: "button",
    variant: "outline",
    p: 2,
    m: 1,
    h: isMobile ? '4.563rem' : '4.688rem',
    w: isMobile ? '5.625rem' : '',
    borderRadius: 4,
    textTransform: "none",
    boxShadow: "inset 0 0 0px 1px ".concat(borderColor),
    color: "baseNeutral.700",
    onClick: onClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: icon,
      alt: iconAlt,
      width: "40",
      height: "40"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: label
    })]
  });
};

/* harmony default export */ var Offers_FilterTagImage = (FilterTagImage);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/switch/dist/index.esm.js
var switch_dist_index_esm = __webpack_require__(68185);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterSwitch.tsx






var FilterSwitch = function FilterSwitch(_ref) {
  var title = _ref.title,
      label = _ref.label,
      isSelected = _ref.isSelected,
      onChange = _ref.onChange;

  var _useState = (0,react.useState)(isSelected),
      checked = _useState[0],
      setChecked = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isMounted = _useState2[0],
      setMount = _useState2[1];

  (0,react.useEffect)(function () {
    setChecked(isSelected);
  }, [isSelected]);
  (0,react.useEffect)(function () {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  var onSwitchChange = function onSwitchChange(evt) {
    var value = evt.target.value;
    setChecked(value === '1');
    onChange(evt);
    return value === '1';
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
      flex: "1",
      textAlign: "left",
      textTransform: "uppercase",
      fontFamily: "Montserrat-SemiBold",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
      as: "span",
      fontFamily: "Montserrat-Medium",
      fontSize: "0.875rem",
      color: "#656b72",
      children: label
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(switch_dist_index_esm/* Switch */.r, {
      colorScheme: "green",
      isChecked: checked,
      float: "right",
      value: "1",
      onChange: onSwitchChange
    })]
  });
};

/* harmony default export */ var Offers_FilterSwitch = (FilterSwitch);
;// CONCATENATED MODULE: ./src/components/common/Spaces/xs.tsx



var StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xs__StyledSpace",
  componentId: "sc-jsscb1-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_xs;
});

var SpaceXS = function SpaceXS() {
  return /*#__PURE__*/_jsx(StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var xs = ((/* unused pure expression or super */ null && (SpaceXS)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/l.tsx



var l_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "l__StyledSpace",
  componentId: "sc-1jip8x3-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_l;
});

var SpaceL = function SpaceL() {
  return /*#__PURE__*/_jsx(l_StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var l = ((/* unused pure expression or super */ null && (SpaceL)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl.tsx



var xxl_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl__StyledSpace",
  componentId: "sc-k5154a-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_xxl;
});

var SpaceXXL = function SpaceXXL() {
  return /*#__PURE__*/_jsx(xxl_StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var xxl = ((/* unused pure expression or super */ null && (SpaceXXL)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl_4.tsx



var xxl_4_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl_4__StyledSpace",
  componentId: "sc-1fuyqpr-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_xxl_4;
});

var SpaceXXL4 = function SpaceXXL4() {
  return /*#__PURE__*/_jsx(xxl_4_StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var xxl_4 = ((/* unused pure expression or super */ null && (SpaceXXL4)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl_5.tsx



var xxl_5_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl_5__StyledSpace",
  componentId: "sc-16fb0l1-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_xxl_5;
});

var SpaceXXL5 = function SpaceXXL5() {
  return /*#__PURE__*/_jsx(xxl_5_StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var xxl_5 = ((/* unused pure expression or super */ null && (SpaceXXL5)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl_6.tsx



var xxl_6_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl_6__StyledSpace",
  componentId: "sc-8dq84s-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_xxl_6;
});

var SpaceXXL6 = function SpaceXXL6() {
  return /*#__PURE__*/_jsx(xxl_6_StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var xxl_6 = ((/* unused pure expression or super */ null && (SpaceXXL6)));
;// CONCATENATED MODULE: ./src/components/common/index.tsx
//TODO move to uikit















/***/ }),

/***/ 4848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ useBackButton; },
/* harmony export */   "rS": function() { return /* binding */ useTracking; }
/* harmony export */ });
/* unused harmony export useQuerystringToFilterOffers */
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70461);
/* harmony import */ var query_string_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31086);
/* harmony import */ var query_string_manager__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(query_string_manager__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4524);
/* harmony import */ var src_redux_sell_offer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7232);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var useQuerystringToFilterOffers = function useQuerystringToFilterOffers(domain) {
  var dispatch = useDispatch();
  var performSearchOffers = domain === 'nlt' ? nltPerformSearchOffers : sellPerformSearchOffers;
  useEffect(function () {
    var qs = queryStringManager.read().get();

    if (Object.entries(qs).length > 0) {
      dispatch(performSearchOffers());
    }
  }, []);
};
var useBackButton = function useBackButton() {
  var onPopState = function onPopState() {
    if (query_string_manager__WEBPACK_IMPORTED_MODULE_4___default().read().get()) {
      location.reload();
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    window.addEventListener('popstate', onPopState);
    return function () {
      window.removeEventListener('popstate', onPopState);
    };
  });
};
var useTracking = function useTracking() {
  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      query = _useRouter.query;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      validQuery = _useState[0],
      setValidQuery = _useState[1];

  var _useCookies = (0,react_cookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(['CP_TRACKER']),
      _useCookies2 = (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_useCookies, 3),
      allCookies = _useCookies2[0],
      setCookie = _useCookies2[1],
      removeCookie = _useCookies2[2];

  var path = '/';
  var today = new Date();
  var validity = parseInt("15");
  var expires = new Date(today.setDate(today.getDate() + validity));
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setValidQuery(query);
  }, [query]);

  var trackingData = function trackingData() {
    return allCookies['CP_TRACKER'];
  };

  var setTracking = function setTracking() {
    var _query$validQuery = _objectSpread(_objectSpread({}, query), validQuery),
        _query$validQuery$utm = _query$validQuery.utm_source,
        source = _query$validQuery$utm === void 0 ? null : _query$validQuery$utm,
        _query$validQuery$utm2 = _query$validQuery.utm_medium,
        medium = _query$validQuery$utm2 === void 0 ? null : _query$validQuery$utm2,
        _query$validQuery$utm3 = _query$validQuery.utm_ref,
        referrer = _query$validQuery$utm3 === void 0 ? null : _query$validQuery$utm3,
        _query$validQuery$utm4 = _query$validQuery.utm_campaign,
        campaign = _query$validQuery$utm4 === void 0 ? null : _query$validQuery$utm4,
        _query$validQuery$utm5 = _query$validQuery.utm_campaign_date,
        campaign_date = _query$validQuery$utm5 === void 0 ? null : _query$validQuery$utm5;

    if ((source || medium || referrer) && (typeof allCookies['CP_TRACKER'] === 'undefined' || !allCookies['CP_TRACKER'])) {
      setCookie('CP_TRACKER', {
        source: source,
        referrer: referrer,
        medium: medium,
        campaign: campaign,
        campaign_date: campaign_date
      }, {
        path: path,
        expires: expires
      });
    }
  };

  var removeTracking = function removeTracking() {
    return removeCookie('CP_TRACKER');
  };

  return [setTracking, removeTracking, trackingData];
};

/***/ }),

/***/ 88142:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noleggio-a-lungo-termine",
      function () {
        return __webpack_require__(20210);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCookies; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie.parse(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/Cookies.js

/* harmony default export */ var react_cookie_es6_Cookies = (es6);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/CookiesContext.js


var CookiesContext = react.createContext(new react_cookie_es6_Cookies());
var Provider = CookiesContext.Provider, Consumer = CookiesContext.Consumer;
/* harmony default export */ var es6_CookiesContext = (CookiesContext);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/utils.js
function isInBrowser() {
    return (typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
}

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/useCookies.js



function useCookies(dependencies) {
    var cookies = (0,react.useContext)(es6_CookiesContext);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    var initialCookies = cookies.getAll();
    var _a = (0,react.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0,react.useRef)(allCookies);
    if (isInBrowser()) {
        (0,react.useLayoutEffect)(function () {
            function onChange() {
                var newCookies = cookies.getAll();
                if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
                    setCookies(newCookies);
                }
                previousCookiesRef.current = newCookies;
            }
            cookies.addChangeListener(onChange);
            return function () {
                cookies.removeChangeListener(onChange);
            };
        }, [cookies]);
    }
    var setCookie = (0,react.useMemo)(function () { return cookies.set.bind(cookies); }, [cookies]);
    var removeCookie = (0,react.useMemo)(function () { return cookies.remove.bind(cookies); }, [cookies]);
    return [allCookies, setCookie, removeCookie];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}


/***/ }),

/***/ 34755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TN":"Lasciati guidare verso\\nla scelta dell’auto migliore","BH":"https://static1.carplanner.com/website/assets/index-head.jpg","Oc":"CarPlanner ti propone le offerte di auto nuove più competitive\\nsul mercato sia per l’acquisto che per il Noleggio a Lungo Termine","qk":[{"image":"https://static1.carplanner.com/website/assets/noleggia-la-tua-auto-a-lungo-termine-2.png","title":"Noleggia la tua auto a lungo termine","description":"Cerchi un’alternativa all’acquisto di un’auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/noleggio-a-lungo-termine","alt":"Scopri tutte le offerte di Noleggio a Lungo Termine","target":"_self"},{"image":"https://static1.carplanner.com/website/assets/acquista-la-tua-nuova-auto-online-2.png","title":"Acquista la tua nuova auto online","description":"Cerchi la tua\\nnuova auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/offerte-auto","alt":"Scopri tutte le offerte di Auto in Vendita","target":"_self"}],"PX":{"a":"Contattaci ora"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6741,1315,7651,3877,7855,7120,2668,9774,2888,179], function() { return __webpack_exec__(88142); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);